import { Button, Divider, Empty, Flex, Typography } from 'antd';
import type { FC } from 'react';
import { AppModal } from '@/components/ui/AppModal';

const { Text } = Typography;

export interface ProductForOrder {
  __typename?: 'product';
  id: string;
  name: string;
}

export interface OrderDrawerFormPositionsModalProps {
  onAddToOrderPosition: (position: ProductForOrder) => void;
  setAddProductModalVisible: (v: boolean) => void;
  addProductModalVisible: boolean;
  productsWithoutOrder: ProductForOrder[];
}

export const OrderDrawerFormPositionsModal: FC<OrderDrawerFormPositionsModalProps> = ({
  onAddToOrderPosition,
  setAddProductModalVisible,
  addProductModalVisible,
  productsWithoutOrder,
}) => {
  return (
    <AppModal
      title="Add product to Order"
      open={addProductModalVisible}
      onCancel={() => setAddProductModalVisible(false)}
      footer={null}
      styles={{ body: { maxHeight: '60vh', overflowY: 'auto', padding: '12px 0' } }}
    >
      {productsWithoutOrder.length === 0 ? (
        <Empty description="No products available to add" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <Flex vertical>
          {productsWithoutOrder.map((product, index) => (
            <div key={product.id}>
              {index > 0 && <Divider style={{ margin: 0 }} />}
              <Flex
                justify="space-between"
                align="center"
                style={{ padding: '10px 0' }}
                data-testid="product-row"
              >
                <Text>{product.name}</Text>
                <Button
                  type="primary"
                  size="small"
                  aria-label={`Add to Order, ${product.name}`}
                  onClick={() => onAddToOrderPosition(product)}
                >
                  Add to Order
                </Button>
              </Flex>
            </div>
          ))}
        </Flex>
      )}
    </AppModal>
  );
};
